module.exports = __webpack_public_path__ + "img/close.3e7b72ae.svg";